module.exports = __webpack_public_path__ + "img/disabled_transfer.53c57546.svg";